"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.bulkMoveRecipeSectionsMutationOptions = exports.bulkMoveRecipeSectionsMutation = void 0;
const client_1 = require("@apollo/client");
const recipesByCookbookAndSectionId_1 = require("../queries/recipesByCookbookAndSectionId");
const updateQuery_1 = require("../../../utils/updateQuery");
exports.bulkMoveRecipeSectionsMutation = client_1.gql `
  mutation BulkMoveRecipeSections($options: BulkMoveRecipeOptions!) {
    bulkMoveRecipeSections(options: $options) {
      ok
    }
  }
`;
exports.bulkMoveRecipeSectionsMutationOptions = (variables, sectionIdToRemove, recipeInfos, destination) => ({
    variables,
    update: cache => {
        if (sectionIdToRemove) {
            try {
                const data = cache.readQuery({
                    query: recipesByCookbookAndSectionId_1.recipesByCookbookAndSectionIdQuery,
                    variables: { sectionId: sectionIdToRemove },
                });
                if (data) {
                    cache.writeQuery({
                        query: recipesByCookbookAndSectionId_1.recipesByCookbookAndSectionIdQuery,
                        variables: {
                            sectionId: sectionIdToRemove,
                        },
                        data: {
                            __typename: "Query",
                            recipesByCookbookAndSectionId: data.recipesByCookbookAndSectionId.filter(x => !variables.options.recipeIds.includes(x.id)),
                        },
                    });
                }
            }
            catch (_a) { }
        }
        if (recipeInfos) {
            try {
                const data = cache.readQuery({
                    query: recipesByCookbookAndSectionId_1.recipesByCookbookAndSectionIdQuery,
                    variables: { sectionId: variables.options.targetSectionId },
                });
                if (data) {
                    cache.writeQuery({
                        query: recipesByCookbookAndSectionId_1.recipesByCookbookAndSectionIdQuery,
                        variables: {
                            sectionId: variables.options.targetSectionId,
                        },
                        data: {
                            __typename: "Query",
                            recipesByCookbookAndSectionId: [
                                ...data.recipesByCookbookAndSectionId,
                                ...recipeInfos,
                            ],
                        },
                    });
                }
            }
            catch (_b) { }
        }
        if (destination && sectionIdToRemove) {
            variables.options.recipeIds.forEach(recipeId => {
                updateQuery_1.updateFragment(cache, `Recipe:${recipeId}`, `
              cookbookSectionLookup {
                cookbook {
                  id
                  name
                  accessLevel
                }
                section {
                  id
                  name
                }
              }
      `, x => {
                    if (x.cookbookSectionLookup) {
                        const idx = x.cookbookSectionLookup.findIndex(y => y.section.id === variables.options.sectionIdToRemove);
                        if (idx === -1) {
                            x.cookbookSectionLookup.unshift(destination);
                        }
                        else {
                            x.cookbookSectionLookup[idx] = destination;
                        }
                    }
                });
            });
        }
    },
});
//# sourceMappingURL=bulkMoveRecipeSections.js.map